const shared_environment: any = {
  accountAppPath: '/account',
  adobeAutosearchUrl:
    'https://content.atomz.com/autocomplete/sp10/04/f8/c6/?query=',
  adobeBodyScript:
    'if(_satellite && _satellite.pageBottom) { _satellite.pageBottom();}',
  adobeMbox: 'target-global-mbox',
  adobeTargetDisabled: false,
  appTheme: 'white-background',
  denaliUrl: 'https://tickets2.universalorlando.com',
  baseRedirectBypass: true,
  digitalDataAdblockerEnabled: false,
  digitalDataAppVersion: '1.0',
  digitalDataDestination: 'UO',
  digitalDataEnabled: true,
  digitalDataFlashVersion: '',
  digitalDataSegment: 'B2C',
  bingSiteVerificationKey: '695C8D6126AB21D375502ECC658DADD5',
  cardinalScriptUrl:
    'https://songbirdstag.cardinalcommerce.com/cardinalcruise/v1/songbird.js',
  digitalDataTridionVersion: 'site9',
  facebookLikeUrl: 'https://www.facebook.com/UniversalOrlandoResort/',
  fontCssUrl: 'assets/fonts/_fonts.css',
  iconCssUrl: 'assets/icons/_font-face.css',
  geo: {
    apiUrl: '/api/geo/location',
    service:
      'https://geo-location-prod.use.ucdp.net/GeoDirectoryServer-7.2.0/v1/ipinfo/',
    disabled: false,
    location: {
      akamai: false,
    },
    region: {
      primary: '',
    },
  },
  googleCalendarApiKey: '',
  googleSiteVerificationKey: 'ammiNOphmIzZZZCvL2SUchOTkKnjM1ydny4KqL_ERW4',
  globalNavigationEnabled: true,
  grecaptchaApiUrl: '//www.google.com/recaptcha/api.js',
  grecaptchaSiteKey: '6LfEHyYTAAAAAGZu9fnOAAkhJhB5_Ylz6VNNMQZe',
  grecaptchaEnabled: false,
  grecaptchaTestResponse: 'bc1f106a-adb7-45e8-b314-0a61febd5555',

  layoutHeader: '_LayoutHeader.html',
  oauthAppFlowPath: '/guestauth/app/token',
  oauthAppPasswordFlowPath: '/guestauth/user/token',
  oauthAppSourceId: '1002062',

  oneTrustDomainScript: '',
  oneTrustEnabled: false,
  oneTrustModalScript: '',
  oneTrustCrossorigin: 'anonymous',
  oneTrustPrivacyScript: '',
  oneTrustPrivacyIds: 'dummy',
  oneTrustPrivacyGeo: 'US',
  oneTrustPrivacyLSPA: 'false',
  coveo: {
    enabled: true,
    scriptSearchUrl:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/CoveoJsSearch.Lazy.min.js',
    scriptSearchHash:
      'sha512-0TQxte3BQBFm6LMBjWvy7BSL3OfnzWeZan5bGVd2B/If/9wIYL7ipAWDRtI8HsM08TwP0c6DYnhfy9cOGe56hg==',
    scriptTemplateUrl:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/templates/templates.j',
    scriptTemplateHash:
      'sha512-eiSn4qRsVzoRB0c52nRdn8mWn04bANr/LV3rXslk9b+PLN73I6aod28OyEbPTn7iMETKQHlSPESNdosKL/Cp8w==',
    css: 'https://static.cloud.coveo.com/searchui/v2.10094/3/css/CoveoFullSearch.min.css',
    cssHash:
      'sha512-TBs03XI7M4g24z1tWm/81JbvLmC37V35QJxFCayy4NH0yDZ46d/zYlgO9QxLPBu2DmKEsKQxtqfgOU/GfvIRwA==',
    crossOrigin: 'anonymous',
    accessKeyID: 'xxf6d142fb-2bea-4a24-9123-26d2cccb0163',
    organizationId: 'nbcuniversalnonproduction10wz5488n',
    scriptLocale:
      'https://static.cloud.coveo.com/searchui/v2.10094/3/js/cultures/es-es.js',
    scriptLocaleHash:
      'sha512-qFjeMB7hdq+a25Bedf+7iUMML1MhsfdSdng2Te69YmR/et5iIxZlK381Wey234INGujG1xN0oGLo4LdzX5A/7g==',
  },

  seoDescription:
    'The various areas with different expressions are a different world full of excitement. A theme park with world-class entertainment that can be enjoyed by both children and adults, including exciting rides themed after Hollywood blockbusters and shows starring popular characters.',
  seoImage:
    'https://www.universalorlando.com/tridiondata/k2/en/us/files/Images/universal-orlando-resort-color-logo-b.png',
  seoFacebookSiteName: 'Universal Orlando Resort',
  seoTwitterSiteName: '@UniversalORL',
  sorryPagePath: '/oops-sorry',
  tridionBaseUrl: '/tridiondata',
  tripDetailLink: '/web-packages/en/us/shopping-cart/{requestId}',
  uprvUrl:
    'https://res.alpha.universalorlandovacations.com/Booking/Retrieval/Default.aspx?confirmationNo=Reservation_ID&id_token_hint=token_id',
  upsellPackages: 'H572, H573',
  wcsStoreId: '10851',
  weatherApi: '',
  uniWebServiceApiKey: 'WebApp',
  shareQrCodeUrl: '/guest/entitlements/{guestId}/{mediaId}',
  linkEntitlement: '/guests/{guest-id}/link-entitlements',
  gtmId: 'GTM-5JHWPZQQ',
  crewToolsApi: '',
  rToasterTagId: '',
};

// export const environment = merge(shared_environment, udeploy);
export const environment = shared_environment;
